export default __webpack_public_path__ + "static/media/card-m-press.ff7fbaaf.png";